/* eslint-disable */
// AUTO-GENERATED - DO NOT EDIT
import { z, testRegex } from '@talbenmoshe/atlas-api/client';
export { toSnakeCase } from './caseTransform.js';
// ============ Component Validation Schemas ============
export const ServiceStatusResponseSchema = z.object({
    service: z.string(),
    databaseValue: z.string(),
}).loose();
export const SignedInAccountResponseSchema = z.object({
    accountId: z.string(),
    email: z.string(),
}).loose();
export const NotSignedInErrorSchema = z.object({
    reason: z.literal('not-signed-in'),
}).loose();
// ============ Request Schemas ============
export const GetTripOsServerStatusRequestSchema = z.object({}).loose();
export const GetSignedInAccountRequestSchema = z.object({}).loose();
// ============ Response Schemas ============
export const ServiceStatusResponseResponseSchema = ServiceStatusResponseSchema;
export const SignedInAccountResponseResponseSchema = SignedInAccountResponseSchema;
// ============ Inferred Type Exports ============
// These types represent the transformed output (camelCase) from Zod schemas.
// Use these types for consumer-facing APIs instead of wire-format types.
//# sourceMappingURL=TripOsServerAPISchemas.js.map